

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22.828","height":"16"}, rest), [h('g', {"transform":"translate(0 4)"}, [h('rect', {"width":"9","height":"7","x":".5","y":".5","fill":"none","stroke":"#262626","rx":"1"}, []), h('path', {"fill":"#262626","d":"M12 1.172v5.656L9.172 4z"}, [])])]);
};

        